'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRouter = require('react-router');
var _connect = require('react-redux/lib/connect/connect');var _connect2 = _interopRequireDefault(_connect);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxPagan = require('redux-pagan');
var _registrationLogo = require('../../../static/images/registrationLogo.png');var _registrationLogo2 = _interopRequireDefault(_registrationLogo);
var _AuthenticationContainer = require('../../containers/AuthenticationContainer/AuthenticationContainer');var _AuthenticationContainer2 = _interopRequireDefault(_AuthenticationContainer);
var _constants = require('../../constants');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _UserAuthenticationPage = require('./UserAuthenticationPage.scss');var styles = _interopRequireWildcard(_UserAuthenticationPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

UserAuthenticationPage = function (_React$Component) {_inherits(UserAuthenticationPage, _React$Component);function UserAuthenticationPage() {var _temp, _this, _ret;_classCallCheck(this, UserAuthenticationPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    handleTabClick = function (type, event) {
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + type));
      var hiddenElement = event.currentTarget;
      hiddenElement.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
        inline: 'center' });

    }, _temp), _possibleConstructorReturn(_this, _ret);}UserAuthenticationPage.prototype.

  render = function render() {var
    translate = this.props.translate;

    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        _react2.default.createElement(_AuthenticationContainer2.default, {
          isRedirectEnabled: true,
          title: translate('authenticationPage', 'welcome'),
          activeTab:
          (0, _get2.default)(this.props, 'routeData.location') ||
          _constants.userAuthenticationPageTabs.SIGN_IN,

          onTabClick: this.handleTabClick }),

        _react2.default.createElement('div', { className: styles.logo },
          _react2.default.createElement('img', { src: _registrationLogo2.default, alt: '' }))));



  };return UserAuthenticationPage;}(_react2.default.Component);


UserAuthenticationPage.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  routeData: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale };};exports.default =


(0, _connect2.default)(mapStateToProps)(UserAuthenticationPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/UserAuthenticationPage/UserAuthenticationPage.js
// module id = 3111
// module chunks = 0